<template>
    <div id="middle-content" class="thankyou">
        <bread-crumb :breadcrumb="[
            { title: 'Home', url: '/', status: false },
            { title: 'Newsletter', url: '/newsletter', status: false },
            { title: 'Terima Kasih', url: '/newsletter/thank-you', status: true }]">
        </bread-crumb>
        <section id="thankyou_text" class="section with_pad">
            <div class="wrapper">
                <div class="main_title">
                    <h3>Terima Kasih</h3>
                    <p class="font-s-18">Selamat kamu akan menjadi orang pertama yang akan mengetahui produk dan promo
                        terbaru dari Astra
                        Honda Motor.</p>
                </div>
                <div class="row_form">
                    <div class="row_button">
                        <a href="/" class="red_bt inliner">Kembali</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb.vue";
export default {
    components: {
        'bread-crumb': BreadCrumb,
    },
    created() {
        if (localStorage.getItem('newsletter') != null) {
            var trackerLayer = {
                'event': 'newSubscription',
                'eventDetail.category': 'New Newsletter Subscription',
                'eventDetail.action':'Thank You Page',
                'eventDetail.label': 'Showing Thank You Page',
                'pageURL': window.location.href
            }
            dataLayer.push(trackerLayer);
            setTimeout(function () {
                var submission = JSON.parse(localStorage.getItem('newsletter'));
                localStorage.removeItem('newsletter');
            }, 2000);
        } else {
            this.$router.push({ path: '/newsletter' });
        }
    },
}
</script>
<style lang="scss" scoped>
.with_pad {
    padding: 40px 0;
}

section {
    position: relative;

}

.line_title {
    width: 100%;
    margin-bottom: 20px;
    display: block;
    position: relative;
}

.line_title h3 .icon {
    display: inline-block;
    float: left;
    width: 50px;
    height: 50px;
    margin-top: 10px;
    background-repeat: no-repeat !important;
    margin-right: 10px;
}

.line_title h3 {
    color: #e21823;
    text-transform: uppercase;
    display: grid;
    grid-template-columns: minmax(20px, 0.1fr) auto minmax(20px, 1fr);
    align-items: center;
    grid-gap: 20px;
    width: 100%;
    margin: 0;
    font-size: 30px;
    line-height: 62px;
    color: #e92030;
}

.line_title h3:before,
.line_title p:before,
.line_title p:after,
.line_title h3:after {
    content: "";
    border-top: 3px solid #e21823;
    width: auto !important;
    height: auto;
    position: relative !important;
    top: 0 !important;
    transform: none;
}

.line_title p {
    margin: 0;
}

.row_form {
    padding-bottom: 20px;
}

.row_form .main_title {
    text-align: left;
    margin-bottom: 15px;
}

.row_form .main_title h3 {
    font-size: 24px;
}

.group_form {
    display: block;
    width: 100%;
    margin-bottom: 15px;
}

.row_form {
    padding-bottom: 20px;
}

.row_form .main_title {
    text-align: left;
    margin-bottom: 15px;
}

.row_form .main_title h3 {
    font-size: 24px;
}

.group_form {
    display: block;
    width: 100%;
    margin-bottom: 15px;
}

.main_title {
    display: block;
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
}

.main_title h3,
.page_title h1 {
    font-size: 42px;
    line-height: 62px;
    color: #e92030;
    margin: 0;
    text-transform: uppercase;
}

.page_title {
    margin: 20px 0;
}

.page_title h1 {
    text-align: left;
}

.main_title p {
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    color: #424242;
}

// FORM STYLE
fieldset {
    margin: 0;
    border: none;
    padding: 0;
}

.form-group {
    position: relative;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;

    label {
        margin-bottom: 5px;
        font-size: 14px;
        text-transform: uppercase;
        color: #424242;
    }
}

.form-radio-custom {
    padding: 10px 20px;
    border: 1px solid #CCC;
    margin-bottom: 15px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;

    label {
        cursor: pointer;
        width: 100%;
        height: 100%;
    }
}

.form-radio-custom.selected {
    background: #E61B33;
    color: #FFF;
}

.form-control {
    padding: 13px 20px;
    border: 1px solid #CCC;
    margin-bottom: 10px;
    border-radius: 10px;
    display: flex;
    font-size: 14px;
}

input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
    /* For iOS < 15 to remove gradient background */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    transform: translateY(-0.075em);
    display: none;
    place-content: center;
}

input[type="radio"]::before {
    content: "";
    width: 25px;
    height: 25px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(#FFF);
    background-color: #FFF;
}

input[type="radio"]:checked::before {
    transform: scale(1);
}

// input[type="radio"]:focus {
//     outline: max(2px, 0.15em) solid #E61B33;
//     outline-offset: max(2px, 0.15em);
// }
.subtitle-section {
    margin-bottom: 10px;
    color: #424242;
    text-transform: uppercase;
}

.red_bt {
    background: #e72233 none repeat scroll 0 0;
    border: none;
    color: #fff;
    cursor: pointer;
    display: block;
    margin: 0 10px;
    text-transform: capitalize;
    font-family: oswald, sans-serif;
    padding: 6px 20px;
    width: auto;
    font-size: 14px;
    height: 34px;
    line-height: 1.4em;
    border-radius: 10px;
}

.red_line_bt {
    background: #FFF;
    border: 1px solid #DBDBDB;
    color: #e72233;
    cursor: pointer;
    // display: block;
    margin: 0 10px;
    text-transform: capitalize;
    font-family: oswald, sans-serif;
    padding: 6px 20px;
    width: auto;
    font-size: 14px;
    height: 34px;
    line-height: 1.4em;
    border-radius: 10px;
}

.black_tx {
    color: #4F4F4F;
    text-transform: capitalize;
    font-size: 16px;

    &:hover {
        background: #e72233;
        color: #FFF;
    }
}

.row_button {
    display: block;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 10;
}

.error {
    border: 1px solid #e21823 !important;
}


.font-s-18 {
    font-size: 18px !important;
}
</style>
